import { useSelector } from "react-redux";

export const useOptional = () => {
    return useSelector((state) => state.optional);
};
